import { render, staticRenderFns } from "./ListPOI.vue?vue&type=template&id=7bd95ee9"
import script from "./ListPOI.vue?vue&type=script&lang=js"
export * from "./ListPOI.vue?vue&type=script&lang=js"
import style0 from "./ListPOI.vue?vue&type=style&index=0&id=7bd95ee9&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports